module.exports = __webpack_public_path__ + "img/能源对比分析.50b52925.png";